import { render } from "./ReviewCard.vue?vue&type=template&id=f435962e&scoped=true"
import script from "./ReviewCard.vue?vue&type=script&lang=js"
export * from "./ReviewCard.vue?vue&type=script&lang=js"

import "./ReviewCard.vue?vue&type=style&index=0&id=f435962e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f435962e"]])

export default __exports__